import { EntityDetailPage, EntityDetailView } from "../common/entity/EntityDetailPage";
import { EntityDetailViewProps } from "../common/entity/EntityInterfaces";
import { EntityTablePage } from "../common/entity/EntityTablePage";
// import { GenericEntityTable } from "../Entities/GenericComponents/common/GenericEntityTable";
import { AuditLogDetail } from "./AuditLogsDetail";
import { AuditLogTable } from "./AuditLogTable";

export const AuditLogsTablePage = () => {
  return (
    <EntityTablePage entityTypeId={"auditLogs"}>
      {(props) => (
        // <GenericEntityTable
        //   entityTypeId="auditLogs"
        //   componentProps={{ ...props, showPermissionColumn: false, readonly: true, disablePermissionQuery: true }}
        // />
        <AuditLogTable {...props} />
      )}
    </EntityTablePage>
  );
};

export const AuditLogsDetailView = ({ id }: EntityDetailViewProps<"auditLogs">) => {
  return (
    <EntityDetailView id={id} entityTypeId={"auditLogs"}>
      {(props) => <AuditLogDetail {...props} />}
    </EntityDetailView>
  );
};

export const AuditLogDetailsPage = () => {
  return <EntityDetailPage<"auditLogs"> isIntId>{(id) => <AuditLogsDetailView id={id} />}</EntityDetailPage>;
};
